class OfflineDataBase{
    constructor(){
    }

    async insert(data = [], table = ''){}

    async destroy(){}

    async select(id){}

    async selectTimeWindow(ids = [], start, end){}
}

export default OfflineDataBase;



// WEBPACK FOOTER //
// ./src/AAFPersistenceManager/offline/OfflineDataBase.js